export interface HighlightPart {
	content: string;
	highlighted: boolean;
}

export interface HighlightMatch {
	/** Match score. Higher is better */
	score: number;
	parts: HighlightPart[];
}

export class Highlighter {
	static highlight(str: string, value: string): HighlightMatch {
		if (value == null) {
			return {
				score: 0,
				parts: [{ content: str, highlighted: false }],
			};
		}

		const length = value.length;
		const indexes = Highlighter.indexesOf(str, value);
		const parts: HighlightPart[] = [];

		Highlighter.addContent(parts, str.substring(0, indexes[0]), false);

		for (let i = 0; i < indexes.length; i++) {
			const index = indexes[i];
			const match = str.substring(index, index + length);
			const other = str.substring(index + length, indexes[i + 1]);

			Highlighter.addContent(parts, match, true);
			Highlighter.addContent(parts, other, false);
		}

		const score = Highlighter.getScore(str, parts);
		return { score, parts };
	}

	private static indexesOf(str: string, value: string): number[] {
		const indexes = [];

		for (var i = 0; i < str.length; i++) {
			const possible = str.substr(i, value.length);

			if (Highlighter.matches(possible, value)) {
				indexes.push(i);
			}
		}

		return indexes;
	}

	protected static matches(a: string, b: string): boolean {
		return a.toLowerCase() === b.toLowerCase();
	}

	private static addContent(parts: HighlightPart[], content: string, highlighted: boolean) {
		if (content == null || content === '') {
			return;
		}

		parts.push({ content, highlighted });
	}

	private static getScore(str: string, parts: HighlightPart[]): number {
		// How early in the string is the match found
		const firstMatchScore = 1 - parts.findIndex((p) => p.highlighted) / parts.length;

		// How much of the string has been matched
		let matchedCharCount = 0;
		for (const part of parts) {
			if (part.highlighted) {
				matchedCharCount += part.content.length;
			}
		}
		const matchCompletenessScore = matchedCharCount / str.length;

		return firstMatchScore * matchCompletenessScore;
	}
}
